import { CheckCircleIcon } from "@heroicons/react/20/solid";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "../../../store/actions/leaveActions";
import OccupationalLeaveRules from "./OccupationalLeaveRules";
import { useEffect } from "react";

const LeaveSettings = ({ saveLeaveRules, disabled, isBeta, getLeaveRules }) => {
	useEffect(() => {
		getLeaveRules();
	}, []);

	if (!isBeta) return null;
	return (
		<form
            className="px-8"
			onSubmit={(e) => {
				e.preventDefault();
				e.stopPropagation();
				saveLeaveRules();
			}}
		>
			<OccupationalLeaveRules />

			<div
				className="col-xs-12 pr-0"
				style={{ paddingBottom: "8rem" }}
			>
				{!disabled && (
					<button
						className="btn btn-success pull-right"
						type="submit"
					>
						<CheckCircleIcon style={{ height: "1.5em", float: "left", marginRight: 5 }} />
						<div style={{ float: "left" }}>Save</div>
					</button>
				)}
			</div>
		</form>
	);
};

const mapStateToProps = (state) => {
	return {
		isBeta: state.company?.settings?.isBeta,
		disabled:
			state?.permissions?.my?.permissions?.settings == "Read" || state?.company?.settings?.status == "Archived",
	};
};

const mapDispatchToProps = (dispatch) => ({
	getLeaveRules: () => dispatch(ACTIONS.getLeaveRules()),
	saveLeaveRules: () => dispatch(ACTIONS.saveLeaveRules()),
});

export default connect(mapStateToProps, mapDispatchToProps)(LeaveSettings);
